<template>
    <div id="addCharge" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{title}}</div>
                    <router-link class="btn btn-secondary pull-right" href="javascript:void(0)" v-bind:to="'/charge/list'" >
                        <i class="fp-back"> </i> Back
                    </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="chargeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="charge_identifier">Charge Identifier :</label>                                        
                                        <input :readonly="editCharge == 1" type="text" class="form-control" v-model="charge_identifier" id="charge_identifier" name="charge_identifier">
                                        <div class="field-error">{{charge_identifier_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="charge_name">Charge Name:</label>
                                        <input type="text" class="form-control" v-model="charge_name" id="charge_name" name="charge_name">
                                        <div class="field-error">{{charge_name_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <div class="charge-type-label">
                                        <label class="control-label require" for="charge_type">Charge Type:</label>
                                            <v-select v-model="charge_type" class="custom-vselect" placeholder="Select Charge Type"
                                                        id="charge_type" label="text" :options="chargeTypeArr"></v-select>
                                            <div class="field-error">{{charge_type_msg}}</div>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="charge_name">Rate:</label>
                                        <input type="text" class="form-control" v-model="rate" id="rate" name="rate" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{rate_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="module">Module:</label>
                                        <v-select type="text" class="custom-ci-auto-search close-remove multiselect" :multiple="true" v-model="module_id" label="text" :options="moduleArr" id="module" placeholder="Select Module" name="module"></v-select>
                                        <div class="field-error">{{module_error_msg}}</div>
                                    </div>
                                     <div class="col form-group custom-checkbox customPadding">
                                        <div class="form-check form-check-inline">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="section_update" id="section_update" name="section_update">  Update In Card Rate
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <ul v-if="formerrors.length">
                                    <li v-for = "formerror in formerrors" :key="formerror.id" v-bind:class="msgClass" >{{formerror}}</li>
                                </ul>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createChargeBtn" class="btn btn-primary" v-on:click.prevent="AddCharge('')" >
                                        <i class="fp-save"> </i> Save
                                    </button>
                                    <button v-if="add_charge_id == 0" type="submit" id="createAndContinueChargeBtn" class="btn btn-tertiary" v-on:click.prevent="AddCharge(flag='continue')" >
                                        <i class="fp-save-continue"> </i> Save and Continue
                                    </button>
                                    <button id="cancelChargeBtn" class="btn btn-tertiary" v-on:click.prevent="listcharge()" >
                                        <i class="fp-close"> </i> Cancel
                                    </button>    
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";

    import {commonMixins} from '../../mixins/commonMixins';
    
    

    export default {
        name: "addCharge",
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Charge | " +process.env.COPYRIGHT_NAME : "Create Charge | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins],
        data: () => ({
            editCharge:false,
            title:"Add Charge",
            formerrors: [],
            Registerchargebtn:"Add",
            cancelbtn:false,
            msgClass: "",
            charge_identifier:"",
            charge_name:"",
            charge_type:null,
            rate:"",
            charge_identifier_msg:"",
            charge_name_msg:"",
            charge_type_msg:"",
            rate_msg:"",
            chargeTypeArr:[{value: 'day', text: "Day"},
                {value: 'month', text: "Month"},
                {value: 'week', text: "Week"},
                {value: 'mile', text: "Mile"},
                {value: 'fixed', text: "Fixed"}
            ],
            add_charge_id:0,
            permissions:[],
            cantAccessPage:"",
            loading:false,
            section_update:false,
            moduleArr:[],
            module_id:'',
            module_error_msg:'',
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'add_charges') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        mounted: function() {

            var self = this;

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3])
            {
                this.add_charge_id = segments[3];
            }


            if(this.$route.query.token == 'list'){

                self.cancelbtn = true;
            }

            if ( this.add_charge_id != 0 ) {

                //change text of button
                setTimeout(function(){
                    $("#createChargeBtn").text("Update");
                },1000);

                this.title = "Update Charge";
                self.editCharge = true;

                //get contact object
                $.ajax({
                    url: process.env.ROOT_API +"/get_charge?id="+self.add_charge_id,
                    type: "GET",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            //console.log(data.content);
                            self.charge_identifier = data.content.charge_identifier;
                            self.charge_name = data.content.charge_name;
                            if(data.content.charge_type == null || data.content.charge_type == ""){
                                self.charge_type = null;
                            }else{
                                self.charge_type = {value:data.content.charge_type,text:self.formatString(data.content.charge_type)};
                            }
                            if(data.content.module_name == null || data.content.module_name == ""){
                                self.module_id = null;
                            }else{
                                // self.module_id = {value:data.content.module_name,text:self.formatString(data.content.module_name)};
                                self.module_id = data.content.module_name;
                            }
                            self.rate = data.content.rate;

                            if (data.content.update_section == 1){
                                self.section_update = true;
                            }


                        }
                    },
                    error: function(jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,false,'get-charge-data-by-id')
                    }
                });
            } else {
                setTimeout(function(){
                    $("#createChargeBtn").text("Save");
                },500);
            }

            self.getModules();
            self.getPermissions();

        },
        methods:{

            AddCharge: function(flag) {

                var self = this;

                this.charge_identifier = $("#charge_identifier").val();
                this.charge_name = $("#charge_name").val();
                this.rate = $("#rate").val();

                //   var formerrors_msg = "";
                this.formerrors = [];
                self.charge_identifier_msg = "";
                self.charge_name_msg = "";
                self.charge_type_msg = "";
                self.rate_msg = "";
                self.module_error_msg = "";


                if (!this.charge_identifier) {
                    self.charge_identifier_msg = "Charge Identifier Required.";
                }
                if (!this.charge_name) {
                    self.charge_name_msg = "Charge Name Required.";
                }

                if (!this.charge_type || self.charge_type.value == "") {
                    self.charge_type_msg = "Charge Type Required.";
                }
                if (!this.module_id || self.module_id == "") {
                    self.module_error_msg = "Module Required.";
                }
                if (!this.rate) {
                    self.rate_msg = "Rate Required.";
                }
                if (this.charge_type == null ) {
                    self.charge_type_msg = "Charge Type Required.";
                }
                if (self.charge_identifier_msg == "" && self.charge_name_msg == ""
                    && self.rate_msg =="" && self.charge_type_msg == "" && self.module_error_msg == "" ) {

                    var fields = $("#chargeForm").serializeArray();
                    fields.push({name: 'charge_type', value: self.charge_type.value});
                    fields.push({name: 'module_id', value: JSON.stringify(self.module_id)});
                    // fields.push({name: 'user_id', value: userId });
                    fields.push({name:'update_section',value:self.section_update});
                    if(self.add_charge_id != 0){
                        fields.push({name: 'id', value: self.add_charge_id });
                    } else {
                        $("#createAndContinueChargeBtn").prop("disabled",true);
                        $("#createAndContinueChargeBtn").text("Processing...");
                    }

                    $("#createChargeBtn").prop("disabled",true);
                    $("#cancelChargeBtn").prop("disabled",true);

                    $("#createChargeBtn").text("Processing...");

                    $.ajax({
                        url: process.env.ROOT_API + "/add_charge",
                        type: "POST",
                        crossDomain: true,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data: fields,
                        success: function(data) {

                            if(self.add_charge_id == 0){

                                $("#createChargeBtn").text("Save");
                                $("#createAndContinueChargeBtn").text("Save and Continue");
                                $("#createAndContinueChargeBtn").prop("disabled",false);
                            } else {
                                $("#createChargeBtn").text("Update");
                            }

                            $("#createChargeBtn").prop("disabled",false);
                            $("#cancelChargeBtn").prop("disabled",false);

                            if (data.status == "success") {

                                self.formerrors.push(data.message);
                                if ( flag != "continue") {
                                    self.$router.push("/charge/list");
                                }else {
                                    self.charge_identifier = "";
                                    self.charge_name = "";
                                    self.charge_type = null;
                                    self.rate = "";
                                }

                                self.msgClass = "success";
                                // $("#chargeForm").trigger("reset");


                            } else if (data.status == "error") {

                                //add errors in formerror array
                                for(var i=0; i<data.content.length; i++) {
                                    self.formerrors.push(data.content[i]);
                                }

                                self.msgClass = "error";
                            }
                        },
                        error: function(jqXHR, exception) {

                            if(self.add_charge_id != undefined){
                                $("#createChargeBtn").text("Save");
                                $("#createAndContinueChargeBtn").text("Save and Continue");
                                $("#createAndContinueChargeBtn").prop("disabled",false);
                            } else {
                                $("#createChargeBtn").text("Update");
                            }

                            $("#createChargeBtn").prop("disabled",false);
                            $("#cancelChargeBtn").prop("disabled",false);

                            self.generateStatusCodeMessage(jqXHR,false,'add-charge-data')
                        }
                    });
                } else {
                    console.log($(".error_style").length);
                    self.msgClass = "error";
                    self.errorValidationFocus();
                   
                }
            },
            listcharge:function(){
                var self = this;

                self.$router.push("/charge/list");

            },
            getModules:function(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/get_modules_by_package",
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{
                        flag : 'all'
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.moduleArr = data;
                        console.log(data);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-module-by-package')
                    }
                });
            },
            formatString(data){
                var self = this;
                var value = data.replace(/_/g," ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },

        }

    }
</script>



// WEBPACK FOOTER //
// src/components/charge/ChargeCreate.vue